module.exports = __webpack_public_path__ + "media/images/pages/img_digest_area_02-c74b65fd4f9edd27ac6ca35fbed35039.jpg";